/**
 * AI feature constants
 */
export const AI_CHAT_MODEL_STORAGE_KEY = "ai-chat-selected-model";
export const AI_CHAT_VISUALIZATION_STORAGE_KEY =
  "ai-chat-visualization-enabled";
/** Browser-persistent switch for auto-submitting eligible tool confirmations. */
export const AI_CHAT_AUTO_APPROVE_TOOLS_STORAGE_KEY =
  "ai-chat-auto-approve-tools";
